import { NgModule } from '@angular/core';

import { JsonHTMLPipe } from '../pipes/json-html.pipe';
import { TrimPipe } from '../pipes/trim.pipe';

@NgModule({
  imports: [
  ],
  declarations: [
    JsonHTMLPipe,
    TrimPipe,
  ],
  exports: [
    JsonHTMLPipe,
    TrimPipe,
  ]
})
export class PipeModule { }


// WEBPACK FOOTER //
// ./src/app/shared/pipe.module.ts